import isLoyaltyProductTypeBonusApplicable from './isLoyaltyProductTypeBonusApplicable'

function isLoyaltyCalculationRequestWithBonus(request: App.LoyaltyPointsEarnCalculationRequest): request is App.LoyaltyPointsEarnCalculationRequestWithBonus {
  return isLoyaltyProductTypeBonusApplicable(request.loyaltyProductType)
}

export default isLoyaltyCalculationRequestWithBonus
